export default "__VITE_ASSET__CfAWCM0I__"